// game id
import GameIds from '../hub/data/GameIds';

export const GAME_ID = GameIds.FOOD_TRUCK;

// app pages
export const APP_PAGES = {
  LOADING: 'loading',
  STANDARD: 'standard',
  PROGRESS: 'progress',
  LEVEL_SUMMARY: 'levelsummary',
  INSTRUCTION: 'instruction',
  ONBOARDING: 'onboarding',
};

// onboarding round statuses
export const ONBOARDING_STATUSES = {
  STARTED: 'ONBOARDING_STARTED',
  INTERRUPTED: 'ONBOARDING_INTERRUPTED',
};

// standard round statuses
export const STANDARD_ROUND_STATUSES = {
  STARTED: 'STANDARD_ROUND_STARTED',
  INTERRUPTED: 'STANDARD_ROUND_INTERRUPTED',
  COMPLETED: 'STANDARD_ROUND_COMPLETED',
};

// animations
export const ANIMATION_CORRECT_ANSWER_MS = 500;
export const ANIMATION_INCORRECT_ANSWER_MS = 1700;
export const ANIMATION_GOBLIN_EAT_PAUSE_MS = 1700;

// audios
export const INITIAL_AUDIO_DELAY_MS = 500;

// Alex states
export const ALEX_SILENT_STATE = 0;
export const ALEX_SPEAK_STATE = 1;

// curriculum actions
export const SELECT_LEVEL = 'FOOD_TRUCK_SELECT_LEVEL';
export const INIT_CURRICULUM = 'FOOD_TRUCK_INIT_CURRICULUM';

// standard round actions
export const INIT_ONBOARDING = 'FOOD_TRUCK_INIT_ONBOARDING';
export const INTERRUPT_ONBOARDING = 'FOOD_TRUCK_INTERRUPT_ONBOARDING';
export const INIT_STANDARD_ROUND = 'FOOD_TRUCK_INIT_STANDARD_ROUND';
export const NEXT_STANDARD_QUESTION = 'FOOD_TRUCK_NEXT_STANDARD_QUESTION';
export const COMPLETE_STANDARD_ROUND = 'FOOD_TRUCK_COMPLETE_STANDARD_ROUND';
export const INTERRUPT_STANDARD_ROUND = 'FOOD_TRUCK_INTERRUPT_STANDARD_ROUND';
export const MARK_PROGRESS = 'FOOD_TRUCK_MARK_PROGRESS';
export const QUICK_ROUND = 'FOOD_TRUCK_QUICK_ROUND';
export const QUICK_FAIL = 'FOOD_TRUCK_QUICK_FAIL';

// audio sequence actions
export const INIT_SEQUENCE = 'FOOD_TRUCK_INIT_SEQUENCE';

// goblin actions
export const INIT_GOBLINS_LINE = 'FOOD_TRUCK_INIT_GOBLINS_LINE';
export const MOVE_GOBLINS_LINE = 'FOOD_TRUCK_MOVE_GOBLINS_LINE';
export const GOBLIN_IDLE = 'FOOD_TRUCK_GOBLIN_IDLE';
export const GOBLIN_WRONGORDER = 'FOOD_TRUCK_GOBLIN_WRONGORDER';
export const GOBLIN_YUM = 'FOOD_TRUCK_GOBLIN_YUM';
export const GOBLIN_EATING = 'FOOD_TRUCK_GOBLIN_EATING';

// navigator actions
export const LOAD_PROGRESS_PAGE = 'FOOD_TRUCK_LOAD_PROGRESS_PAGE';
export const LOAD_LEVEL_SUMMARY_PAGE = 'FOOD_TRUCK_LOAD_LEVEL_SUMMARY_PAGE';
export const LOAD_ONBOARDING_PAGE = 'FOOD_TRUCK_LOAD_ONBOARDING_PAGE';
export const LOAD_STANDARD_PAGE = 'FOOD_TRUCK_LOAD_STANDARD_PAGE';
export const LOAD_INSTRUCTION_PAGE = 'FOOD_TRUCK_LOAD_INSTRUCTION_PAGE';
export const LOAD_LOADING_PAGE = 'FOOD_TRUCK_LOAD_LOADING_PAGE';

// animation and dropzone actions
export const INIT_DROP_ZONE_LAYOUT = 'FOOD_TRUCK_INIT_DROP_ZONE_LAYOUT';
export const TURN_DROP_ZONE_ON = 'FOOD_TRUCK_TURN_DROP_ZONE_ON';
export const TURN_DROP_ZONE_OFF = 'FOOD_TRUCK_TURN_DROP_ZONE_OFF';

export const TURN_ANIMATED_KNIFE_ON = 'FOOD_TRUCK_TURN_ANIMATED_KNIFE_ON';
export const TURN_ANIMATED_KNIFE_OFF = 'FOOD_TRUCK_TURN_ANIMATED_KNIFE_OFF';
export const TURN_TILE_ANIMATION_ON = 'FOOD_TRUCK_TURN_TILE_ANIMATION_ON';
export const TURN_TILE_ANIMATION_OFF = 'FOOD_TRUCK_TURN_TILE_ANIMATION_OFF';
export const SWITCH_RESET_BUTTON_ANIMATION = 'FOOD_TRUCK_SWITCH_RESET_BUTTON_ANIMATION';
export const SWITCH_ONBOARDING_TILE_ANIMATION = 'FOOD_TRUCK_SWITCH_ONBOARDING_TILE_ANIMATION';

// question actions
export const INIT_TRAY = 'FOOD_TRUCK_INIT_TRAY';
export const RELOAD_TRAY = 'FOOD_TRUCK_RELOAD_TRAY';
export const ADD_TILE_TO_DESK = 'FOOD_TRUCK_ADD_TILE_TO_DESK';
export const REMOVE_TILE_FROM_DESK = 'FOOD_TRUCK_REMOVE_TILE_FROM_DESK';
export const REORDER_TILES_ON_DESK = 'FOOD_TRUCK_REORDER_TILES_ON_DESK';
export const CUT_TILE = 'FOOD_TRUCK_CUT_TILE';
export const SERVE_ANSWER = 'FOOD_TRUCK_SERVE_ANSWER';
export const TURN_SECOND_ATTEMPT_MODE_ON = 'FOOD_TRUCK_TURN_SECOND_ATTEMPT_MODE_ON';
export const TURN_TRY_AGAIN_MODE_ON = 'TURN_TRY_AGAIN_MODE_ON';
export const REPLACE_DESK_WITH_CORRECT_ANSWER_TILE = 'FOOD_TRUCK_REPLACE_DESK_WITH_CORRECT_ANSWER_TILE';

// Alex actions
export const ALEX_SPEAK = 'FOOD_TRUCK_ALEX_SPEAK';
export const ALEX_SILENT = 'FOOD_TRUCK_ALEX_SILENT';

// game details actions
export const UPDATE_GAME_PRACTICE_DETAILS = 'FOOD_TRUCK_UPDATE_GAME_PRACTICE_DETAILS';
export const UPDATE_GAME_ONBOARDING_DETAILS = 'FOOD_TRUCK_UPDATE_GAME_ONBOARDING_DETAILS';

// metadata constants
export const NUM_LEVELS = 9;
export const LAST_AVAILABLE_LEVEL_ID = 8;

// amount of correct answers user needs to give in order to become mastered for level
export const MASTERED_LEVEL_THRESHOLD = 5;
export const QUESTIONS_PER_ROUND = 6;

// max amount of letters on the desk
export const DESK_WEIGHT_LIMIT = 8;

// array with goblins ids
export const GOBLINS_IDS = [1, 2, 3, 4, 5];

// goblin animation keys
export const GOBLIN_ANIMATION_KEYS = {
  IDLE: 'GOBLIN_IDLE',
  YUM: 'GOBLIN_YUM',
  WRONGORDER: 'GOBLIN_WRONGORDER',
  EATING: 'GOBLIN_EATING',
};
